import { render, staticRenderFns } from "./NetizenLesson.vue?vue&type=template&id=1f60c492"
import script from "./NetizenLesson.vue?vue&type=script&lang=js"
export * from "./NetizenLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports